/**
 * @Author: JulienBigot7 julien@generation-internet.biz
 * @Date: 2024-12-05 15:00:08
 * @LastEditors: JulienBigot7 julien@generation-internet.biz
 * @LastEditTime: 2024-12-05 17:42:10
 * @FilePath: src/utils/formFunc/date-utils.ts
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
export const getHHhmmDateFormat = (
  date: Date,
  { replaceSeparator = "h" } = {},
): string => {
  const dateObject = new Date(date);

  const localStringDate = dateObject.toLocaleDateString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });

  // verify if safari
  if (localStringDate.includes("à")) {
    return localStringDate.split("à")[1].replace(":", replaceSeparator);
  } else {
    // it's not safari
    return localStringDate.split(" ")[1].replace(":", replaceSeparator);
  }
};
